import React from 'react'

// eslint-disable-next-line no-unused-vars
import { styled, Chip, ChipProps, lighten } from '@material-ui/core'
import clsx from 'clsx'

const StyledChip = styled(Chip)(({ theme }) => ({
  borderRadius: 8,

  '& > .MuiChip-label': {
    paddingTop: 4,
    fontWeight: 600,
    lineHeight: '1rem',
    fontSize: '0.65rem',
    textTransform: 'uppercase',
    fontFamily: '"Roboto", sans-serif',
  },

  // Custom
  '&.MuiChip-filledSuccess.slim': {
    backgroundColor: lighten(theme.palette.success.main, 0.9),

    '& > .MuiChip-icon, & > .MuiChip-label': {
      color: theme.palette.success.dark,
    },
  },

  '&.MuiChip-filledWarning.slim': {
    backgroundColor: lighten(theme.palette.warning.main, 0.9),

    '& > .MuiChip-icon, & > .MuiChip-label': {
      color: theme.palette.warning.dark,
    },
  },

  '&.MuiChip-filledError.slim': {
    backgroundColor: lighten(theme.palette.error.main, 0.9),

    '& > .MuiChip-icon, & > .MuiChip-label': {
      color: theme.palette.error.dark,
    },
  },

  '&.MuiChip-filledSecondary.slim': {
    backgroundColor: lighten(theme.palette.secondary.main, 0.9),

    '& > .MuiChip-icon, & > .MuiChip-label': {
      color: theme.palette.secondary.main,
    },
  },
}))

// ----------------------------------------------------------------------

/**
 * @typedef {ChipProps} StatusProps
 * @property {'default' | 'slim' } mode
 *
 *
 * @param {StatusProps} props
 * @returns
 */
export function Status(props) {
  const { mode, className, ...other } = props

  return <StyledChip {...other} className={clsx(className, mode)} />
}
